<template>
  <div>
    <BaseButton
      type="outlined"
      :label="t('auth.continueWithEmail')"
      prepend-icon="icon-mail"
      icon-class="!mr-2"
      :icon-size="18"
      color="primary-1"
      background-color="white"
      hover-color="primary-1"
      hover-background-color="none"
      :height="40"
      class="!w-full !text-[14px] !font-medium !rounded tracking-wide !border-[#dadce0]"
      @click="nextStep"
    />
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n();
const emit = defineEmits(["show-email-form"]);
defineProps({
  isDesktop: { type: Boolean, default: false },
});
const nextStep = () => {
  emit("show-email-form", true);
};
</script>
